var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQualityShield = function SvgQualityShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.497 1.552 1.78 3.991a.44.44 0 0 0-.281.402c.016 2.872 1.2 7.833 5.825 10.058a.41.41 0 0 0 .353 0c4.625-2.225 5.81-7.186 5.822-10.058a.45.45 0 0 0-.281-.402zm.419-1.46 5.887 2.51A1.95 1.95 0 0 1 15 4.399c-.016 3.117-1.29 8.82-6.675 11.413a1.9 1.9 0 0 1-1.65 0C1.288 13.219.013 7.516 0 4.399a1.95 1.95 0 0 1 1.197-1.797L7.08.092a1 1 0 0 1 .835 0"
  })));
};
export default SvgQualityShield;